import services from 'admin/services'

export default {
  getPlans() {
    return services.fetch('/v1/billing/plans')
  },

  getCustomPlan() {
    return services.fetch('/v1/billing/custom-plan')
  },

  getMerchantId() {
    return services.fetch('/v1/billing/merchant-id')
  },

  getToken() {
    return services.fetch('/v1/billing/token')
  },

  getCountries() {
    return services.fetch('/v1/billing/countries')
  },

  getEuCountries() {
    return services.fetch('/v1/billing/countries/eu')
  },

  validateVat(country, vatId) {
    return services.fetch(
      '/v1/billing/vat-id',
      {
        method: 'POST',
        body: {
          country,
          vatId,
        },
      }
    )
  },

  validateCoupon(coupon) {
    return services.fetch(
      '/v1/billing/coupon',
      {
        method: 'POST',
        body: {
          coupon,
        },
      }
    )
  },

  calculateTotal(country, price) {
    return services.fetch(
      '/v1/billing/total',
      {
        method: 'POST',
        body: {
          country,
          price,
        },
      }
    )
  },

  createSubscription(body, reCaptchaToken) {
    if(reCaptchaToken) {
      body.reCaptchaToken = reCaptchaToken;
    }
 
    return services.fetch(
      '/v1/billing/subscriptions',
      {
        method: 'POST',
        body,
      }
    )
  },

  updateSubscription(body) {
    return services.fetch(
      '/v1/admin/subscriptions',
      {
        method: 'PUT',
        body,
      }
    )
  },

  reCreateSubscription(planId) {
    return services.fetch(
      '/v1/admin/subscriptions',
      {
        method: 'POST',
        body: {
          planId,
        },
      }
    )
  },

  cancelSubscription() {
    return services.fetch(
      '/v1/admin/subscriptions',
      {
        method: 'DELETE',
      },
    )
  },

  getSubscription() {
    return services.fetch(
      '/v1/admin/subscriptions'
    )
  },

  getSubscriptionPaymentMethod() {
    return services.fetch(
      '/v1/admin/subscriptions/payment-method'
    )
  },

  getBillingInfo() {
    return services.fetch(
      '/v1/admin/subscriptions/billing-info'
    )
  },

  changePlan(planId) {
    return services.fetch(
      '/v1/admin/subscriptions/plans',
      {
        method: 'PUT',
        body: {
          planId,
        },
      }
    )
  },

  requestQuote(email) {
    return services.fetch(
      '/v1/billing/request-quote',
      {
        method: 'POST',
        body: {
          email,
        },
      }
    )
  },
}
